module.exports = __webpack_public_path__ + "static/webpack-config-89caa82073c8aeec3b1fb30e4f255db3.png";